
export const BINANCE_NAME = 'Binance';
export const BYBIT_NAME = 'Bybit';